import { createVuetify } from "vuetify"
import "vuetify/styles"
import "@mdi/font/css/materialdesignicons.css"
import {
	VApp,
	VAlert,
	VAutocomplete,
	VNavigationDrawer,
	VBtn,
	VCard,
	VCardActions,
	VCardText,
	VSheet,
	VCardTitle,
	VChip,
	VCol,
	VContainer,
	VDialog,
	VDivider,
	VExpansionPanel,
	VExpansionPanels,
	VExpansionPanelText,
	VExpansionPanelTitle,
	VDataTable,
	VDataTableServer,
	VDataTableHeaders,
	VDataTableFooter,
	VTable,
	VForm,
	VIcon,
	VImg,
	VLabel,
	VCheckbox,
	VList,
	VListItem,
	VListItemSubtitle,
	VListItemTitle,
	VMenu,
	VBreadcrumbs,
	VBreadcrumbsItem,
	VBreadcrumbsDivider,
	VProgressCircular,
	VProgressLinear,
	VRow,
	VSelect,
	VSnackbar,
	VSpacer,
	VTextarea,
	VTextField,
	VTab,
	VTabs,
} from "vuetify/components"
import { Ripple } from "vuetify/directives"

export const vuetify = createVuetify({
	components: {
		VApp,
		VContainer,
		VBreadcrumbs,
		VBreadcrumbsItem,
		VBreadcrumbsDivider,
		VBtn,
		VRow,
		VCheckbox,
		VSelect,
		VDialog,
		VLabel,
		VImg,
		VNavigationDrawer,
		VAutocomplete,
		VProgressCircular,
		VProgressLinear,
		VDataTable,
		VDataTableServer,
		VDataTableHeaders,
		VDataTableFooter,
		VAlert,
		VCol,
		VForm,
		VTextField,
		VTextarea,
		VCard,
		VCardTitle,
		VSheet,
		VCardText,
		VCardActions,
		VList,
		VTab,
		VTabs,
		VListItem,
		VListItemTitle,
		VTable,
		VListItemSubtitle,
		VDivider,
		VIcon,
		VChip,
		VSnackbar,
		VExpansionPanels,
		VExpansionPanel,
		VExpansionPanelTitle,
		VExpansionPanelText,
		VSpacer,
		VMenu,
	},
	directives: {
		Ripple,
	},
	icons: {
		defaultSet: "mdi",
	},
})
